import { Tooltip } from "@mui/material";

const AppTooltip = ({ id, children, tooltip, placement }) => {
  return (
    <Tooltip id={id} title={tooltip} placement={placement || "top"} enterDelay={300} leaveDelay={150}>
      <span style={{ display: "inline-flex" }}>{children}</span>
    </Tooltip>
  );
};

export default AppTooltip;
